export const services = [
  {
    id: 1,
    title: 'İntermodal',
    icon: 'Container',
    description: 'Çok modlu taşımacılık çözümleri',
    link: '/services/intermodal'
  },
  {
    id: 2,
    title: 'Demir Yolu',
    icon: 'TrainFront',
    description: 'Demiryolu taşımacılığı hizmetleri',
    link: '/services/rail'
  },
  {
    id: 3,
    title: 'Hava Yolu',
    icon: 'Plane',
    description: 'Hızlı hava kargo çözümleri',
    link: '/services/air'
  },
  {
    id: 4,
    title: 'Deniz Yolu',
    icon: 'Ship',
    description: 'Deniz yolu taşımacılığı',
    link: '/services/sea'
  },
  {
    id: 5,
    title: 'Kara Yolu',
    icon: 'Truck',
    description: 'Karayolu taşımacılık hizmetleri',
    link: '/services/road'
  },
  {
    id: 6,
    title: 'Likit Taşımacılık',
    icon: 'Droplets',
    description: 'Sıvı madde taşımacılığı',
    link: '/services/liquid'
  },
  {
    id: 7,
    title: 'Kontrat Lojistiği',
    icon: 'FileText',
    description: 'Sözleşmeli lojistik hizmetleri',
    link: '/services/contract'
  },
  {
    id: 8,
    title: 'Gümrükleme',
    icon: 'FileCheck',
    description: 'Gümrük işlemleri ve danışmanlık',
    link: '/services/customs'
  },
  {
    id: 9,
    title: 'Yurt İçi Taşımacılık',
    icon: 'MapPin',
    description: 'Türkiye geneli taşımacılık',
    link: '/services/domestic'
  }
];

export const stats = [
  { value: '10,000+', label: 'Aylık Taşıma' },
  { value: '5,000+', label: 'Çalışan' },
  { value: '3,000+', label: 'Özmal Araç/Ekipman' }
];

export const newsArticles = [
  {
    id: 1,
    title: 'Movent Logistics Avrupa Ağını Genişletiyor',
    excerpt: 'Movent Logistics, 2025 yılında Avrupa\'daki operasyonlarını genişleterek yeni pazarlara açılıyor.',
    image: 'https://images.unsplash.com/photo-1616432043562-3671ea2e5242?w=800',
    date: '15 Ocak 2025',
    link: '#'
  },
  {
    id: 2,
    title: 'Dijital Dönüşümde Yeni Adım',
    excerpt: 'Movent Logistics, müşteri deneyimini geliştirmek için yeni dijital platformunu hayata geçirdi.',
    image: 'https://images.unsplash.com/photo-1644079446600-219068676743?w=800',
    date: '10 Ocak 2025',
    link: '#'
  },
  {
    id: 3,
    title: 'Sürdürülebilir Lojistik İçin Yatırım',
    excerpt: 'Çevre dostu taşımacılık çözümleri için elektrikli araç filosuna geçiş başladı.',
    image: 'https://images.unsplash.com/photo-1732193933813-4da17265a36c?w=800',
    date: '5 Ocak 2025',
    link: '#'
  },
  {
    id: 5,
    title: 'Sektörün Öncüsü Olmaya Devam Ediyoruz',
    excerpt: 'Lojistik sektöründeki yenilikçi yaklaşımımızla müşterilerimize en iyi hizmeti sunuyoruz.',
    image: 'https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?w=800',
    date: '20 Aralık 2024',
    link: '#'
  }
];

export const offices = [
  {
    title: 'Genel Merkez',
    address: 'Barış, Akdeniz Cd. No:8 D:57, 34520 Beylikdüzü/İstanbul',
    phone: '0212 978 09 78',
    email: 'info@moventlog.com'
  },
  {
    title: 'İstanbul Anadolu Yakası',
    address: 'Barbaros Mah. Mor Sümbül Sk. No:7/3 Ataşehir / İstanbul'
  },
  {
    title: 'İzmir',
    address: 'Kazımdirik Mahallesi 296 Sokak No 8 Bornova / İzmir'
  },
  {
    title: 'Ankara',
    address: 'Kızılırmak, Dumlupınar Blv. No:3 A Blok Çankaya / Ankara'
  },
  {
    title: 'Bursa',
    address: 'Balat Mah. Sıhhiye Cad. No:33 Nilüfer / Bursa'
  },
  {
    title: 'Almanya',
    address: 'Hartham 6, 94152 Neuhaus am Inn, Germany'
  },
  {
    title: 'İtalya',
    address: 'Porto Franco Nuovo 34123 Trieste – Italy'
  },
  {
    title: 'Fransa',
    address: 'Zone Portuaire Route de Pontmartin 34200 Sete – France'
  }
];

export const companyInfo = {
  name: 'Movent Logistics',
  slogan: 'Lojistik Bizimle Kolay.',
  description: 'Uçtan uca lojistik hizmetler sunuyor, işinizi kolaylaştırıyoruz.',
  about: '2015 yılında kurulan Movent Logistics, Türkiye\'nin önde gelen lojistik firmalarından biri olarak sektörde öncü konumdadır. Modern araç filomuz, deneyimli ekibimiz ve teknolojik altyapımızla müşterilerimize en kaliteli hizmeti sunuyoruz.',
  logo: 'https://customer-assets.emergentagent.com/job_serene-roentgen-1/artifacts/4ynwgged_LOGO%20PNG%20-COLOR-02.png'
};